<aca-page-layout>
  <aca-page-layout-header class="smt-custom-list-layout-header">
    <div class="smt-custom-list-header">
      <h3 class="adf-breadcrumb">{{viewerConfig.title | translate }}</h3>
    </div>
    <adf-toolbar class="adf-toolbar--inline">
      <ng-container *ngFor="let entry of actions; trackBy: trackByActionId">
        <aca-toolbar-action [actionRef]="entry"></aca-toolbar-action>
      </ng-container>
    </adf-toolbar>
  </aca-page-layout-header>

  <aca-page-layout-error>
    <aca-generic-error></aca-generic-error>
  </aca-page-layout-error>

  <aca-page-layout-content>
    <div class="main-content">
      <mat-progress-bar color="primary" mode="indeterminate" *ngIf="!smtSearchFilter?.filtersLoaded"></mat-progress-bar>
      <div class="smt-custom-list-search content" [ngStyle]="showFilters ? { display: 'block'} : { display: 'none'}">
        <smt-search-filter [viewerConfig]="viewerConfig" [defaultFilterValues]="defaultFilterValues"></smt-search-filter>
      </div>

      <smt-custom-list-table
        #customList
        smtCustomList
        acaContextActions
        [viewerConfig]="viewerConfig"
        [showMainDatatableActions]="true"
        [display]="documentDisplayMode$ | async"
        selectionMode="multiple"
        [navigate]="false"
        [sorting]="viewerConfig.searchConfig.sorting"
        [additionalSorting]="viewerConfig.searchConfig.additionalSorting"
        [stickyHeader]="viewerConfig.stickyHeader"
        sortingMode="server"
        [multiselect]="true"
        [imageResolver]="customImageResolver"
        (node-dblclick)="onNodeDoubleClick($any($event))"
        (name-click)="onNodeDoubleClick($any($event))"
        (refreshToolbarActions)="refreshToolbarActions()"
        (refreshFilters)="refreshFilters($event)"
      >
        <adf-custom-empty-content-template>
          <ng-container>
            <div class="empty-search__block">
              <p class="empty-search__text">
                {{ 'APP.BROWSE.SEARCH.NO_FILTER_RESULTS' | translate }}
              </p>
            </div>
          </ng-container>
        </adf-custom-empty-content-template>
      </smt-custom-list-table>
      <adf-pagination acaPagination [target]="customList"> </adf-pagination>
    </div>

    <div class="sidebar" *ngIf="infoDrawerOpened$ | async">
      <aca-info-drawer [node]="selection.last"></aca-info-drawer>
    </div>
  </aca-page-layout-content>
</aca-page-layout>
